// Import Modules
import {registerServiceWorker} from './registerServiceWorker';
import $ from 'jquery';

import shareThis from "share-this";
import * as twitterSharer from "share-this/dist/sharers/twitter";
import ScrollReveal from 'scrollreveal'

//globals
let showChar = 150;
let ellipsestext = "...";
let moretext = "show&nbsp;more&nbsp;+";
let lesstext = "show&nbsp;less&nbsp;-";

// Elements
let $contentsBtn = $('.contents-menu--btn');
let $contentsClose = $('#contents-menu--close');
let $contentsMenu = $('.contents-menu--overlay');
let $errorMessage = $('.error-msg');

// Contents Menu
$contentsBtn.on('click', function () {
  $contentsMenu.addClass('--is-open');
})
$('.contents-menu--overlay a')
  .add($contentsClose)
  .on('click', function () {
    $contentsMenu.removeClass('--is-open');
  })

// ShareThis - https://github.com/MaxArt2501/share-this
const selectionShare = shareThis({selector: "#shareable", sharers: [twitterSharer]});
selectionShare.init();

// Register Service Worker
registerServiceWorker();

//sources
$("#sourcesLink").click(function () {
  $("#sourcesContainer")
    .slideToggle("slow", function () {});
});

//poll
$("#poll-button").click(function () {
  // showResults();
});

if (navigator.userAgent.indexOf("MSIE") >= 0) {
  document.getElementById('browser-conditional').style.display = 'block';
}

document.getElementById("modal-close").addEventListener("click", closeModal);

function closeModal(){
  document.getElementById('browser-conditional').style.display = 'none';
}

function showResults() {
  $(".survey-wrapper").hide();
  $('#poll-results').show();
  $(".question--wrap").fadeIn("fast");
}

var pollButton = document.getElementById("poll-button");
var pollLoading = document.getElementById("poll-loading");

pollButton.addEventListener("click", updatePoll);

function updatePoll() {
  $(pollLoading).show();
  $(pollButton).hide();
  var rates = document.getElementsByName('poll');
  for (var i = 0; i < rates.length; i++) {
    if (rates[i].checked) {
      sendRequest(i);
      return
    }
  }
  showErrorMessage("Whoops! Click on an answer to vote.");
  $(pollLoading).hide();
  $(pollButton).show();

}

function showErrorMessage(string) {
  $errorMessage.text(string);
  $errorMessage.show();
}

function hideErrorMessage() {
  $errorMessage.hide();
}

function sendRequest(arrayNo) {
  $.ajax({
    type: 'POST',
    url: 'https://projects.hillarys.co.uk/mars/poll.php',
    crossDomain: true,
    data: {
      data: arrayNo
    },
    success: function (responseData, textStatus, jqXHR) {
      $(pollLoading).hide();
      $(pollButton).show();
      var returnArray = JSON.parse(responseData);
      showResults();
      $('.poll1').css("width", returnArray[0] + "%");
      $('.poll2').css("width", returnArray[1] + "%");
      $('.poll3').css("width", returnArray[2] + "%");
      hideErrorMessage();
    },
    error: function (responseData, textStatus, errorThrown) {
      $(pollLoading).hide();
      $(pollButton).show();
      showErrorMessage("There was an issue with the server, please try again later");
    }
  });
}

//read more
$(".more")
  .each(function () {
    var content = $(this).html();

    if (content.length > showChar) {
      var c = content.substr(0, showChar);
      var h = content.substr(showChar, content.length - showChar);

      var html = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;<a href="" class="morelink">' + moretext + "</a></span>";
      $(this).html(html);
    }
  });

$(".morelink").click(function () {
  if ($(this).hasClass("less")) {
    $(this).removeClass("less");
    $(this).html(moretext);
  } else {
    $(this).addClass("less");
    $(this).html(lesstext);
  }
  $(this)
    .parent()
    .prev()
    .toggle();
  $(this)
    .prev()
    .toggle();
  return false;
});

//local storage
if (!localStorage.takenMarsPoll) {
  // sendRequest(null); show poll
} else {
  localStorage.takenMarsPoll = true;
}
